import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, FormHelperText, Select, MenuItem, CircularProgress, Typography, FormControl } from "@material-ui/core";

const styles = theme => ({
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%",
        marginBottom: '5px'
    }
});

const EmailAuthenticationForm = (props) => {
    const { classes, formSettings, initialValues, handleSubmit, handleLanguageChange, appTranslations, translations, } = props;

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched } = formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            label={translations['email'] || 'Email'}
                            placeholder={translations['email'] || 'Email'}
                            name="Email"
                            fullWidth={true}
                            value={values.Email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            margin="dense"
                            error={!!(errors.Email && touched.Email)}
                        />
                        <FormControl className={classes.formControl} margin={"dense"}>
                            <FormHelperText>{translations['language'] || 'Select language'}</FormHelperText>
                            <Select
                                name="language"
                                label={translations['language'] || 'Select language'}
                                margin={"dense"}
                                value={values.language || 'en'}
                                onChange={handleChange}
                                onClick={handleLanguageChange}
                            >
                                {(appTranslations ? appTranslations : []).map(option => (
                                    <MenuItem key={option.code} value={option.code}>
                                        {option.displayName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !(isValid && dirty)}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null}

                    </form>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(EmailAuthenticationForm);
